// extracted by mini-css-extract-plugin
module.exports = {"navigationMenu":"quarto_navigationMenu__3b-9Y","placeholderShimmer":"quarto_placeholderShimmer__3CQRH"};